import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Favorite as FavoriteIcon, FavoriteBorder as FavoriteBorderIcon } from '@mui/icons-material';
import { useFavorites } from '../hooks/useFavorites';
import { FavoriteEntityType } from '../services/api';

interface FavoriteButtonProps {
  entityType: FavoriteEntityType;
  entityId: string;
  size?: 'small' | 'medium' | 'large';
}

const FavoriteButton: React.FC<FavoriteButtonProps> = ({ entityType, entityId, size = 'small' }) => {
  const { isFavorite, toggleFavorite, isToggling } = useFavorites();
  const active = isFavorite(entityType, entityId);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    toggleFavorite(entityType, entityId);
  };

  return (
    <Tooltip title={active ? 'Dejar de seguir' : 'Seguir'} arrow>
      <IconButton
        size={size}
        onClick={handleClick}
        disabled={isToggling}
        sx={{
          color: active ? 'error.main' : 'text.disabled',
          '&:hover': {
            color: active ? 'error.dark' : 'error.main',
          },
          transition: 'color 0.15s',
        }}
        aria-label={active ? 'Dejar de seguir' : 'Seguir'}
      >
        {active ? (
          <FavoriteIcon fontSize={size} />
        ) : (
          <FavoriteBorderIcon fontSize={size} />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default FavoriteButton;
